
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"149","height":"41","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.286 8.596L10.826 4l-5.77 8.851L4 26.121l11.608 3.066M27.842 8.596L24.37 23.149v9.191l5.904 2.298 11.113-3.447m0 0l1.042-20.68m-1.042 20.68L42.428 40m9.208-.766l-1.09-16.085L52.498 9.36m2.084 3.064l10.07 1.532.695 9.192-10.765 2.68m19.1 13.405l1.736-13.405-1.736-18m-3.82 6.894l11.46-2.298h7.987l2.084 10.724-21.531 6.127m9.724-1.532l16.322 7.277M99.034 7.83l3.473 15.32 1.042 14.553m3.125-28.34l9.724-1.533 10.071 1.15m-10.071 1.531l2.083 22.98 4.168 1.531m7.987-27.192v16.469l1.389 9.957L148 30.042m-13.891-6.893l11.807-3.447m-12.502-8.043l12.502-2.68","stroke":"#fff","stroke-width":"6"}})])
          )
        }
      }
    